<body>

  <div id="container">
    <div id="textcontainer">
      <i class="fa fa-arrow-circle-left fa-3x" aria-hidden="true" (click)="back()" id="back"></i>
      <h4 class="text firsttext " id="">{{ courseTrackName | uppercase }}  
        <div class=" filtertext">Course Track Name</div>  </h4>
      
    <h6 class="text SecondText" id="secondtext"> {{campusName}}</h6>
    <div class=" secondFilter">Campus Name</div>
    </div>
      <form action=""   [formGroup]="initaldta" id="aside" >
        <mat-label class="fonttext">Class</mat-label>
      <!-- <span class="classInput">{{className}}</span> -->
      <input class="classInput" readonly type="text" placeholder="{{className}}">
        <mat-label class="fonttext margintop" [style.color]="verificationlist[0].Color">Year *</mat-label>
        <input class="classInput" placeholder="{{details.academicYear}}" *ngIf="whethereditOrnot;else yearselect" readonly>
        <ng-template #yearselect>
          <mat-select  class="selectOptions" [style.border-color]="verificationlist[0].Color2">
            <input matInput [matAutocomplete]="yearauto" formControlName="year" class="inputborderpopup border"
              placeholder="select city">
            <mat-autocomplete autoActiveFirstOption #yearauto="matAutocomplete">
            </mat-autocomplete>
            <mat-option *ngFor="let item of yearOptions | async" [value]="item" (click)="getacademicId(item)">{{item.academicYear}}</mat-option>
          </mat-select>
        </ng-template>        
      <mat-label class="fonttext margintop"[style.color]="verificationlist[1].Color">Batch *</mat-label>
      <input class="classInput" placeholder='{{details.batchName}}'*ngIf="whethereditOrnot;else Batchselect"readonly>
        <ng-template #Batchselect>
      <mat-select class="selectOptions"[style.border-color]="verificationlist[1].Color2">
        <input matInput [matAutocomplete]="batchauto" formControlName="batch" class="inputborderpopup border"
          placeholder="select batch">
        <mat-autocomplete autoActiveFirstOption #batchauto="matAutocomplete">

        </mat-autocomplete>
        <mat-option *ngFor="let item of batchOptions | async" [value]="item" (click)="getbatchId(item)">{{item.batchName}}</mat-option>
      </mat-select>
    </ng-template>  
      <mat-label class="fonttext margintop"[style.color]="verificationlist[2].Color">Orientation *</mat-label>
      <input class="classInput" placeholder='{{details.orientationType}}' *ngIf="whethereditOrnot;else Orientationselect"readonly>
        <ng-template #Orientationselect>
      <mat-select class="selectOptions"[style.border-color]="verificationlist[2].Color2">
        <input matInput [matAutocomplete]="orientationauto" formControlName="orientation" class="inputborderpopup border"
          placeholder="select orientation">
        <mat-autocomplete autoActiveFirstOption #orientationauto="matAutocomplete">

        </mat-autocomplete>
        <mat-option *ngFor="let item of orientationOptions | async" [value]="item" (click)="getorientationtype(item)">{{item.orientation}}</mat-option>
      </mat-select>
    </ng-template>  
      <mat-label class="fonttext margintop"[style.color]="verificationlist[3].Color">Organisation *</mat-label>
      <mat-select class="selectOptions"[style.border-color]="verificationlist[3].Color2"placeholder='{{details.organizationName}}'
      *ngIf="whethereditOrnot;else orgselect">    
      <input matInput [matAutocomplete]="organisationauto" formControlName="organisation" class="inputborderpopup border"
          placeholder="select organisation">
        <mat-autocomplete autoActiveFirstOption #organisationauto="matAutocomplete">

        </mat-autocomplete>
        <mat-option *ngFor="let item of organisationOptions | async" [value]="item" (click)="getorgId(item)">{{item.orgName}}</mat-option>
      </mat-select>
        <ng-template #orgselect>
      <mat-select class="selectOptions"[style.border-color]="verificationlist[3].Color2">
        <input matInput [matAutocomplete]="organisationauto" formControlName="organisation" class="inputborderpopup border"
          placeholder="select organisation">
        <mat-autocomplete autoActiveFirstOption #organisationauto="matAutocomplete">

        </mat-autocomplete>
        <mat-option *ngFor="let item of organisationOptions | async" [value]="item" (click)="getorgId(item)">{{item.orgName}}</mat-option>
      </mat-select>
    </ng-template>  
      <mat-label class="fonttext margintop" [style.color]="verificationlist[4].Color">Coaching Type *</mat-label>
      <input class="classInput" placeholder='{{details.coachingType}}'*ngIf="whethereditOrnot;else coachingselect"readonly>
        <ng-template #coachingselect>
      <mat-select class="selectOptions"[style.border-color]="verificationlist[4].Color2">
        <input matInput [matAutocomplete]="Coachingauto" formControlName="CoachingControl" class="inputborderpopup border"
          placeholder="select coaching type">
        <mat-autocomplete autoActiveFirstOption #Coachingauto="matAutocomplete">

        </mat-autocomplete>
        <mat-option *ngFor="let item of coachingTypeOptions | async" [value]="item" (click)="getcoachingType(item)">{{item.coachngType}}</mat-option>
      </mat-select>
    </ng-template>  
      <mat-label class="fonttext margintop"[style.color]="verificationlist[5].Color">Program Name *</mat-label>
      <input class="classInput" placeholder='{{details.programName}}'*ngIf="whethereditOrnot;else Programselect"readonly>
        <ng-template #Programselect>
      <mat-select class="selectOptions"[style.border-color]="verificationlist[5].Color2">
        <input matInput [matAutocomplete]="ProgramNameauto"formControlName="programname" class="inputborderpopup border"
          placeholder="select Program Name">
        <mat-autocomplete autoActiveFirstOption #ProgramNameauto="matAutocomplete">

        </mat-autocomplete>
        <mat-option *ngFor="let item of programNameOptions | async" [value]="item"(click)="getprogramId(item)">{{item.programName}}</mat-option>
      </mat-select>
    </ng-template>  
      <mat-label class="fonttext margintop"[style.color]="verificationlist[0].Color">Program Course Track *</mat-label>
      <input class="classInput" placeholder='{{details.promotingCourseTrackId}}' *ngIf="whethereditOrnot;else ProgramCourseselect"readonly>
        <ng-template #ProgramCourseselect>
      <mat-select class="selectOptions"[style.border-color]="verificationlist[0].Color2">
        <input matInput [matAutocomplete]="Trackauto" formControlName="promotingcoursetrack" class="inputborderpopup border"
          placeholder="select Program Course Track">
        <mat-autocomplete autoActiveFirstOption #Trackauto="matAutocomplete">

        </mat-autocomplete>
        <mat-option *ngFor="let item of promotingcoursetrackOptions | async" [value]="item" (click)="promotingcolor()" (click)="getpromtingCourseTrack(item)">{{item.promotingCourseTrackId}}</mat-option>
      </mat-select>
    </ng-template>  
      </form>
    <div id="line"></div>
    <div id="section"  >
      <div id="options" [style.display]="display">
        <div class="checkbox" id=" firstbox" (click)="changecolor()" [style.background-color]="bgcolor"
          (click)="visibleContainer()" (click)="checklist()">
          <img src={{selectImage}} alt="" class="selectImage">
          <h5 class="text1  ">Course Fee</h5>
        </div>
        <div class="checkbox" id="secondbox" (click)="changecolor2()" [style.background-color]="bgcolor2"
          (click)="visibleContainer2()"(click)="checklist2()">
          <img src={{selectImage2}} alt="" class="selectImage">
          <h5 class="text1">Akash Books</h5>
        </div>
      </div>
<div class="maincontainerborder" [style.border]="maincontainerborder1">
      <div id="headContainer" [style.display]="headdisplay" [style.border]="headcontainerborder">
        <h4 id="name" class="firsttext">Course Fee</h4>
        <i class="fa fa-trash-o" id="deletebtn" (click)="clearcoursefee('FEE')"></i>
          <form [formGroup]="data" id="form1"> 
            <div class="headcontainer2">
              <span class="set">
                <mat-label class="fonttext"[style.color]="verifyheadlist[0].Color">Total Course Fee</mat-label>
                <input class="input" matInput  [value]="this.previoustotalcoursefee" formControlName="totalCourseFee"[style.border-color]="verifyheadlist[0].Color2" type="number" > 
            </span>
            <span class="set">
                <mat-label class="fonttext"[style.color]="verifyheadlist[1].Color">Max Concession</mat-label>
                <input class="input" matInput [value]="this.details.maxConcession" formControlName="maxConcession"[style.border-color]="verifyheadlist[1].Color2" type="number"> 
            </span>
            <span class="set">
                <mat-label class="fonttext"[style.color]="verifyheadlist[2].Color">Org Concession</mat-label>
                <input class="input" matInput [value]="this.details.orgConcession" formControlName="orgConcession"[style.border-color]="verifyheadlist[2].Color2"type="number"> 
            </span>
            </div>
           
         <div class="headcontainer2">
          <span class="set">
            <mat-label class="fonttext"[style.color]="verifyheadlist[3].Color">Current Strength</mat-label>
            <input class="input" matInput [value]="this.details.courseStrength" formControlName="currentStrength"[style.border-color]="verifyheadlist[3].Color2"type="number"> 
        </span>
        <span class="set">
            <mat-label class="fonttext"[style.color]="verifyheadlist[4].Color">Registration Fee</mat-label>
            <input class="input" matInput [value]="this.details.registrationFee" formControlName="registrationFee"[style.border-color]="verifyheadlist[4].Color2"type="number"> 
        </span>
        <span class="set">
            <mat-label class="fonttext">PRO Incentive</mat-label>
            <mat-select formControlName="proincentive" id="pro" placeholder="No">
                <mat-option value="option1">Yes</mat-option>
                <mat-option value="option2">No</mat-option>
            </mat-select>
        </span>
         </div>
        </form>
        <div id="buttoncontainer" [style.display]="btndisplay"> 
          <button id="secondbtn" (click)="popvisible('FEE')"><i class="fa  fa-plus"></i> SubHead</button>
        </div>
      </div>
      <div id="akashHeadContainer" [style.display]="headdisplay2" [style.border]="Akashheadcontainerborder">
        <h2 class="firsttext">Akash Books</h2>
        <div id="akashHeadContainer2"  >
          <form [formGroup]="myGroup" id="akashInput">
            <mat-label class="fonttext">Total Amount</mat-label>
            <!-- <i class="fa fa-eyedropper" id="pencilbtn"></i> -->
            <i class="fa fa-trash-o" id="deletebtn" (click)="clearcoursefee('AKASH')" ></i>
            <input type="text" id="AkashInputbox" [value]="previousakashAmount" formControlName="akashdata">
            <button  id="akashbtn" (click)="popvisible('AKASH')" [style.display]="btndisplay2"><i class="fa  fa-plus"></i>SubHead</button>
          </form>
        </div>
      </div>
      <hr id="hr" [style.display]="hrdispaly">
      <div id="headDisplayList" [style.display]="headDisplayList">
        <div id="subheadcontainer">
          <h4 id="headsub" class="firsttext">{{headtypename}}</h4>
          <i class="fa fa-plus" *ngIf="headtypename=='Course Fee '; else first" id="plus" (click)="popvisible('FEE')"></i>
          <ng-template #first>
            <i class="fa fa-plus"  id="plus" (click)="popvisible('AKASH')"></i>
          </ng-template>
        </div>
        <div id="tableContainer" class="table-responsive">
          
              <table id="list" class="table table-striped table-hover table-bordered">
                <thead id="thead">
                  <tr>
                  <td class="tdheight text-center">Sub Head</td>
                  <td class="tdheight text-center">Organisation</td>
                  <td class="tdheight text-center">Tax Type</td>
                  <td class="tdheight text-center">Payment Model</td>
                  <td class="tdheight text-center">Receipt Types</td>
                  <td class="tdheight text-center">Head Amount</td>
                  <td class="tdheight text-center">Edit</td>
                  <td class="tdheight text-center">Delete </td>
                </tr>
                </thead>
                <tbody id="tbody">
                  <tr *ngFor="let item of listtype  ; let i=index">
                    <td class="tdheight">{{item.subTransCode}}</td>
                    <td class="tdheight">{{item.orgShortName}}</td>
                    <td class="tdheight">{{item.taxType}}</td>
                    <td class="tdheight">{{item.displayPaymentModel}}</td>
                    <td class="tdheight">{{item.displatReceiptType}}</td>
                    <td class="tdheight" id="amount"><i class="fa fa-inr" aria-hidden="true"></i>&nbsp;{{item.headAmount}}</td>
                    <td class="tdheight"><i class="fa fa-eyedropper" (click)="gotosubheadpopup(i,true,item)" id="edit"></i></td>
                    <td class="tdheight"><i class="fa fa-trash-o"(click)="deleteitem(i,item.headCode)" id="deletebtn2"></i></td>
                  </tr>
                </tbody>
              </table>  
       </div>
     
    </div>
    </div>
    <div id="submitbuttondiv" [style.display]="submitbuttondiv" >
      <h3 class="submitbutton" id="headnames">{{length}} &nbsp;Heads&nbsp; /&nbsp; RS.&nbsp; {{totalsum}}</h3>
      <button class="submitbutton" (click)="verifyAmount()"> Submit&nbsp;&nbsp;&nbsp;&nbsp;<i class="fa fa-long-arrow-right"></i></button>
    </div>
    </div>
  </div>
  <app-footer></app-footer>
</body>
<!-- ================================ loader ======================-->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>